import React from "react";
import classnames from "classnames";
import { flexRender } from "@tanstack/react-table";

import { isInvalidRow } from "@/react/components/table/useTableMutations";
import StyledTableRow from "@/react/components/styled/table/StyledTableRow";
import StyledTableCell from "@/react/components/styled/table/StyledTableCell";

const TableEditableRow = ({ row, rowsToUpdate, rowsToCreate, onRowClick }) => {
  const isInvalid = isInvalidRow(row.original);
  const isModified = rowsToUpdate?.has(row.id);
  const isNew = rowsToCreate?.has(row.id);

  return (
    <StyledTableRow
      role="row"
      className={classnames({
        invalid: isInvalid,
        modified: !isInvalid && isModified,
        new: !isInvalid && isNew,
      })}
      onClick={() => onRowClick && onRowClick(row)}
    >
      {row.getVisibleCells().map(({ id, column, getContext }) => {
        const isEditingCell =
          row.getIsSelected() && column.columnDef.editable === true;
        const cellRenderer = isEditingCell
          ? column.columnDef.editableCell
          : column.columnDef.cell;
        return (
          <StyledTableCell
            isEditingCell={isEditingCell}
            key={id}
            size={column.getSize()}
            role="cell"
          >
            {flexRender(cellRenderer, getContext())}
          </StyledTableCell>
        );
      })}
    </StyledTableRow>
  );
};

export default TableEditableRow;
